import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import * as moment from 'moment';
import { TourService } from 'app/main/services/tour.service';
import { CartService } from 'app/main/services/cart.service';
import { AppService } from 'app/main/services/app.service';
import { TranslateService } from '@ngx-translate/core';
import { FormArray, FormControl } from '@angular/forms';
declare var $: any;

@Component({
	selector: 'booking-form',
	templateUrl: './booking-form.component.html',
	styleUrls: ['./booking-form.component.scss']
})
export class BookingFormComponent implements OnInit, AfterViewInit{

	public familyCheck = false;
	get record(): any{
		return this.tourService.record;
	}

	/**
	 * check if the roles are all of type group
	 */
	get isGroupRole(): boolean {
		if(this.record.actual_trips_mode === 'external') return false;
		let isGroupRole = true;
		const roleCode = 'FIXED1';
		const tripServiceCatalogItems = this.record.trip_service_catalog_items;
		for (const tripServiceCatalogItem of tripServiceCatalogItems) {
			if (tripServiceCatalogItem.trip_service_rule.code !== roleCode) {
				isGroupRole = false;
				break;
			}
		}
		return isGroupRole;
	}
	get isExternal(): boolean{
		return this.record.actual_trips_mode === 'external';
	}

	@ViewChild('ticketsPopup') ticketsPopup: ElementRef;
	@ViewChild('paxes') paxes: ElementRef;

	added_participant_categories: any = {};
	enabled_participant_categories: any = {};

	public showTicketGroup = false;

	constructor(
		private translate: TranslateService,
		public appService: AppService,
		public tourService: TourService,
		public cartService: CartService){}

	@HostListener('document:click', ['$event'])
	clickout(event: Event): void{}

	setParticipant(code: any, label, newValue: any): void{
		this.added_participant_categories[code] = {label: label, value: newValue};
	}

	deleteParticipant(code: any): void{
		if (this.added_participant_categories[code]) delete this.added_participant_categories[code];
	}

	increment(ageGroup: any): void{
		const previousValue = this.tourService.bookingForm.get(ageGroup.formControlName).value;
		const newValue = previousValue + 1;
		if(this.familyCheck){
			if(ageGroup.code === 'ADT' && newValue > this.tourService.familyLimitADT.max ||
				ageGroup.code === 'CHD' && newValue > this.tourService.familyLimitCHD.max) return previousValue;
		}
		this.setParticipant(ageGroup.code, ageGroup.label, newValue);
		this.tourService.bookingForm.get(ageGroup.formControlName).setValue(newValue);
	}

	decrement(ageGroup: any): void{
		const previousValue = this.tourService.bookingForm.get(ageGroup.formControlName).value;
		let newValue = previousValue - 1;
		
		if(this.familyCheck){
			if(ageGroup.code === 'ADT' && newValue < this.tourService.familyLimitADT.min ||
				ageGroup.code === 'CHD' && newValue < this.tourService.familyLimitCHD.min) return previousValue;
		}
		
		if (newValue <= 0) newValue = 0;
		if (ageGroup.code === 'ADT'){
			if (!this.enabled_participant_categories['SNR'] || this.enabled_participant_categories['SNR'] && this.tourService.bookingForm.get('seniors').value === 0){
				if (newValue <= 0) newValue = 1;
			}
		} else if (ageGroup.code === 'SNR'){
			if (this.enabled_participant_categories['ADT'] && this.tourService.bookingForm.get('adults').value === 0){
				if (newValue <= 0) newValue = 1;
			}
		}
		if (newValue > 0){
			this.setParticipant(ageGroup.code, ageGroup.label, newValue);
		} else this.deleteParticipant(ageGroup.code);

		this.tourService.bookingForm.get(ageGroup.formControlName).setValue(newValue);
	}

	initAgeGroups(): void{
		this.record.trip_service_catalog_items.forEach((tripService: any) => {
			if (!tripService.trip_service_rule || !tripService.trip_service_rule.code) return;
			switch(tripService.trip_service_rule.code){
				case 'SNR':
					this.enabled_participant_categories['SNR'] = {
						code: 'SNR',
						label: 'Seniors',
						formControlName: 'seniors',
						age_from: this.record.properties?.snr_from?.value,
						age_to: this.record.properties?.snr_to?.value
					};
					break;
				case 'PAX':
				case 'ADT':
					this.enabled_participant_categories['ADT'] = {
						code: 'ADT',
						label: 'Adults',
						formControlName: 'adults',
						age_from: this.record.properties?.adult_from?.value,
						age_to: this.record.properties?.adult_to?.value
					};
					break;
				case 'CHD':
					this.enabled_participant_categories['CHD'] = {
						code: 'CHD',
						label: 'Children',
						formControlName: 'children',
						age_from: this.record.properties?.child_from?.value,
						age_to: this.record.properties?.child_to?.value
					};
					break;
				case 'INF':
					this.enabled_participant_categories['INF'] = {
						code: 'INF',
						label: 'Infants',
						formControlName: 'infants',
						age_from: this.record.properties?.inf_from?.value,
						age_to: this.record.properties?.inf_to?.value
					};
					break;
				default:
					this.enabled_participant_categories['ADT'] = {
						code: 'ADT', 
						label: 'Adults', 
						formControlName: 'adults', 
						age_from: this.record.properties?.adult_from?.value,
						age_to: this.record.properties?.adult_to?.value
					};
					break;
			}
		});
	}
	
	initExternalAgeGroup(): void{
		this.enabled_participant_categories['SNR'] = {
			code: 'SNR',
			label: 'Seniors',
			formControlName: 'seniors',
			age_from: this.record.properties?.snr_from?.value,
			age_to: this.record.properties?.snr_to?.value
		};
		this.enabled_participant_categories['ADT'] = {
			code: 'ADT',
			label: 'Adults',
			formControlName: 'adults',
			age_from: this.record.properties?.adult_from?.value,
			age_to: this.record.properties?.adult_to?.value
		};
		this.enabled_participant_categories['CHD'] = {
			code: 'CHD',
			label: 'Children',
			formControlName: 'children',
			age_from: this.record.properties?.child_from?.value,
			age_to: this.record.properties?.child_to?.value
		};
		this.enabled_participant_categories['INF'] = {
			code: 'INF',
			label: 'Infants',
			formControlName: 'infants',
			age_from: this.record.properties?.inf_from?.value,
			age_to: this.record.properties?.inf_to?.value
		};
		console.log(this.enabled_participant_categories);
		this.tourService.disabledPartecipantCategories.forEach((item: any) => {
			delete this.enabled_participant_categories[item];
		});
		
	}
	initFamilyGroup(): void{
		this.enabled_participant_categories['ADT'] = {
			code: 'ADT',
			label: 'Adults',
			formControlName: 'adults',
			age_from: this.record.properties?.adult_from?.value,
			age_to: this.record.properties?.adult_to?.value,
		};
		this.setParticipant('ADT', 'Adults', this.tourService.familyLimitADT);
		this.tourService.bookingForm.get('adults').setValue(this.tourService.familyLimitADT.min === 0 ? 1 : this.tourService.familyLimitADT.min);
		
		this.enabled_participant_categories['CHD'] = {
			code: 'CHD',
			label: 'Children',
			formControlName: 'children',
			age_from: this.record.properties?.child_from?.value,
			age_to: this.record.properties?.child_to?.value,
		};
		this.setParticipant('CHD', 'Children', this.tourService.familyLimitCHD.min);
		this.tourService.bookingForm.get('children').setValue(this.tourService.familyLimitCHD.min);
	}

	toggleTicketGroup(): void{
		if (!this.showTicketGroup && this.tourService.hasTripServices){
			this.showTicketGroup = true;
		} else this.showTicketGroup = false;
	}

	get selectedActualTrip(): any{
		const actualTripId = this.tourService.bookingForm.get('actual_trip_id').value;
		return this.tourService.actualTrips.find(actualTrip => actualTrip.id == actualTripId);
	}

	ngOnInit(): void {
		// init first available date
		this.tourService.selectedDate = this.tourService.actual_trips_first_available_date;

		/** setta partenze selezionate */
		this.tourService.responseData.subscribe(response => {
			this.tourService.bookingForm.get('actual_trip_id').setValue(response.data?.going_trip, {emitEvent: false});
			this.tourService.bookingForm.get('return_trip_id').setValue(response.data?.return_trip, {emitEvent: false});
			if (this.tourService.selectedDate){
				this.tourService.bookingForm.get('date').setValue(moment(this.tourService.selectedDate).format('DD/MM/YYYY'), {emitEvent: false});
			}
			// set resources
			this.tourService.optonalServices();
			this.tourService.selectedDate = this.tourService.actual_trips_first_available_date;
		});
		// init default data
		if(this.record.actual_trips_mode !== 'external'){
			this.initAgeGroups();
		}else{
			this.initExternalAgeGroup();
		}
		
		this.setParticipant('ADT', 'Adults', 1);
		// on certain value change
		this.tourService.bookingForm.valueChanges
		.subscribe(formValues => {
			this.setParticipantsOnValueChanges(formValues);
			// some checks
			if (this.tourService.is_first_loading) return;
			// else reload
			this.tourService.reload();
		});
	}

	/**
	 * al cambio degli inputs dei partecipanti non tramite i pulsanti di azione, aggiorna i counters
	 * @param formValues
	 */
	setParticipantsOnValueChanges(formValues: any): void{
		if (formValues.adults > 0) this.setParticipant('ADT', 'Adults', formValues.adults);
		if (formValues.infants > 0) this.setParticipant('INF', 'Infants', formValues.infants);
		if (formValues.children > 0) this.setParticipant('CHD', 'Children', formValues.children);
		if (formValues.seniors > 0) this.setParticipant('SNR', 'Seniors', formValues.seniors);
	}

	ngAfterViewInit(): void{
		const datePicker = (<any>$('.date-pick')).datepicker({
			language: this.translate.currentLang,
			beforeShowDay: this.disableDaysDynamic.bind(this),
		});
		// on change date
		datePicker.on('changeDate', (e) => {
			datePicker.datepicker('hide');
			const date = moment(new Date(e.date));
			this.tourService.selectedDate = date.format('YYYY-MM-DD');
			// not reload before show booking form
			if (this.tourService.is_first_loading) return;
			// else reload
			this.tourService.clearResources();
			this.tourService.reload(true);
		});
		// on show
		datePicker.on('show', () => {
			$('.prev').text('');
			$('.next').text('');
			$('.date-pick-wrapper').addClass('opened');
		});
		// on hide
		datePicker.on('hide', () => $('.date-pick-wrapper').removeClass('opened'));
		// on month change
		datePicker.on('changeMonth', (e: any) => {
			this.onMonthChange(e.date);
		});

		setTimeout(() => $('.tickets-popup > *').on('click', (event) => event.stopPropagation()));
	}

	disableDaysDynamic(date: Date): boolean{
		if (!date) return;
		const day = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
		.toJSON()
		.split('T')[0];

		if (!this.tourService.avaliable_dates || this.tourService.avaliable_dates.length === 0) return false;
		return this.tourService.avaliable_dates.includes(day);
	}

	addToCart(): void{
		const cartItem = this.tourService.responseData.value.cart_item;
		const formControls = this.tourService.bookingForm.controls;

		if (!cartItem){
			const formDatata = this.tourService.getRawValue();
			formDatata['enabled_participants'] = Object.keys(this.enabled_participant_categories);
			this.cartService.addToCart(formDatata);
		} else {
			const data = {
				date: moment().format('DD/MM/YYYY'),
				adt_counter: formControls['adults'].value,
				chd_counter: formControls['children'].value,
				inf_counter: formControls['infants'].value,
				snr_counter: formControls['seniors'].value,
				trip_booking_id: cartItem.trip_booking_id,
				optional_services: formControls['optional_services'].value,
				optional_return_services: formControls['optional_return_services'].value,
				nation_code: 'GB',
				scenario: 'increment'
			};
			this.cartService.updateCart(cartItem, data);
		}
	}

	onCheckChange(event: any, formControlName: string) {
		const formArray: FormArray = <FormArray>this.tourService.bookingForm.get(formControlName);
		if(event.target.checked){
			formArray.push(new FormControl(event.target.value));
		}else{
			let i: number = 0;
			formArray.controls.forEach((ctrl: FormControl) => {
				if(ctrl.value == event.target.value) {
					formArray.removeAt(i);
					return;
				}
				i++;
			});
		}
	}
	familyCheckChange(): void{
		this.familyCheck = !this.familyCheck
		
		if(this.familyCheck){
			this.enabled_participant_categories = [];
			this.initFamilyGroup();
			this.tourService.bookingForm.get('is_family').setValue(true);
		}else{
			if(this.record.actual_trips_mode !== 'external'){
				this.initAgeGroups();
			}else{
				this.initExternalAgeGroup();
				this.deleteParticipant('CHD');
				this.tourService.bookingForm.get('children').setValue(0);
				this.setParticipant('ADT', 'Adults', 1);
				this.tourService.bookingForm.get('adults').setValue(1);
			}
			this.tourService.bookingForm.get('is_family').setValue(false);
		}
		
	}
	
	onMonthChange(date){
		console.log('Cambio');
		if(this.record.actual_trips_mode === 'external' && this.record.ticketlandia_museum_id_event_id){
			this.tourService.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
			this.tourService.reload();
		}
	}
	
	
}
